import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Griddle, { plugins } from 'griddle-react';
import WebHotelListItem from './WebHotelListItem';

function hasHotels(hotels) {
  if (!hotels) {
    return false;
  }
  if (Object.prototype.hasOwnProperty.call(hotels, 'length')) {
    return hotels.length !== 0;
  }
  return false;
}

const CustomTableComponent = OriginalComponent =>
  class CustomTableComponent extends React.Component {
    static contextTypes = {
      components: PropTypes.object,
    };

    render() {
      return <this.context.components.TableBody />;
    }
  };

const CustomTableBody = ({ rowIds, Row, style, className }) => (
  <div style={style} className={className}>
    {rowIds && rowIds.map(r => <Row key={r} griddleKey={r} />)}
  </div>
);
const sortProperties = [
  { id: 'selected', sortAscending: false },
  { id: 'distance', sortAscending: true },
  { id: 'name', sortAscending: true }
];

class WebHotelList extends React.Component {
  constructor(props) {
    super(props);
    this.selectHotelList = this.selectHotelList.bind(this);
    this.favHotel = this.favHotel.bind(this);
  }
  selectHotelList(hotelData) {
    this.props.formatSelectedHotel(hotelData)
    console.log('select hotel from list', hotelData, this.props.eventId);
    this.props.selectHotelFromWeb(this.props.eventId, hotelData, (response) =>{
        //Do Nothing
    });
  }
  favHotel(hotelId, fav) {
    this.props.favoriteHotel(hotelId, fav);
  }

  render() {
    const CustomRowComponent = connect((state, props) => ({
      rowData: plugins.LocalPlugin.selectors.rowDataSelector(state, props),
    }))(({ rowData }) => (
     <WebHotelListItem
        hotel={rowData}
        selectHotel={this.selectHotelList}
        groupId={this.props.event.event.group}
        event={this.props.event}
        displayError={this.props.displayError}
      />
    ));

    if (!hasHotels(this.props.hotels)) {
      return <p>No hotels found. Please modify your search preferences.</p>;
    }
    return (
      <div className="add-hotel-popup-hotels-list">
        <Griddle
          data={this.props.hotels}
          pageProperties={{
            pageSize: 10,
          }}
          plugins={[plugins.LocalPlugin]}
          sortProperties={sortProperties}
          components={{
            Row: CustomRowComponent,
            TableContainer: CustomTableComponent,
            TableBody: CustomTableBody,
            SettingsToggle: () => <span />,
          }}
        />
      </div>
    );
  }
}

WebHotelList.propTypes = {
  hotels: PropTypes.arrayOf(PropTypes.object).isRequired,
  eventId: PropTypes.number.isRequired,
  selectHotel: PropTypes.func.isRequired,
  favoriteHotel: PropTypes.func.isRequired,
  displayHotel: PropTypes.func.isRequired,
};

WebHotelList.defaultProps = {
  hotels: [],
};
export default WebHotelList;



// WEBPACK FOOTER //
// src/routes/tours/components/WebHotelList.js